import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseCrossWhite = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.87075 5.21716L2.03611 0.382439C1.6625 0.00881577 1.01091 -0.246846 0.381995 0.3821C-0.246921 1.01105 0.00805163 1.66335 0.381657 2.03697L5.22172 6.87711L6.87075 5.21716ZM0.295773 15.1556C-0.0263566 15.5384 -0.196877 16.1365 0.381995 16.7154C1.01091 17.3444 1.66318 17.0894 2.03678 16.7158L2.10266 16.6495C2.11518 16.636 2.12786 16.6228 2.14069 16.61L16.6558 1.99887C17.0078 1.61911 17.211 0.973603 16.6191 0.381737C15.9902 -0.24721 15.3386 0.00845194 14.965 0.382075L14.191 1.16125C14.1643 1.19314 14.1365 1.22345 14.1079 1.25204L0.295773 15.1556ZM10.181 11.8365L11.83 10.1765L16.7147 15.0612C17.0883 15.4349 17.3439 16.0865 16.715 16.7154C16.1031 17.3274 15.4338 17.0894 15.0602 16.7158L10.181 11.8365Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgCloseCrossWhite);
export { ForwardRef as ReactComponent };
